import React from 'react';
import toast from 'react-hot-toast';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { NavLink } from 'react-router-dom';


function Footer() {
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        toast.success('Thanks your for your Subscribe!!.')
        form.reset()
    }
    return (
        <div className='container mx-auto xl:px-32 pt-20'>
            <div className=' grid grid-cols-1 md:grid-cols-2 mx-5 lg:grid-cols-4 '>
                <div className='col-span-1 mx-auto mb-10 lg:mb-0'>
                    <NavLink to='/'>
                        <div className='flex items-center gap-3'>
                            <div className="avatar">
                                <div className="w-16 rounded-full ring ring-[#4E545B] ring-offset-base-100 ring-offset-2">
                                    <img src="https://i.ibb.co/dD7d8Kj/shijan.jpg" alt='phot' />
                                </div>
                            </div>
                            <div>
                                <h2 className='text-2xl text-[#BBC6D4] font-bold'>Md Shijan Ali</h2>
                            </div>
                        </div>
                    </NavLink>
                    <div className='mt-10 flex gap-6'>
                        <div className=' shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                            <a href="https://facebook.com/mdshijanali135" target='_blank' rel="noreferrer"><FaFacebookF className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaFacebookF></a>
                        </div>
                        <div className='shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                            <a href="https://twitter.com/shijan135" target='_blank' rel="noreferrer"><FaTwitter className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaTwitter></a>
                        </div>
                        <div className='shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                            <a href="https://linkedin.com/in/mdshijanali" target='_blank' rel="noreferrer"><FaLinkedinIn className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaLinkedinIn></a>
                        </div>
                    </div>
                </div>

                <div className='col-span-1 mx-auto my-10 lg:my-0'>
                    <h2 className='uppercase text-xl text-[#ff014f] mb-6'>quick link</h2>

                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> About </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Portfolio </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Services </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Blog </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Contact </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                </div>

                <div className='col-span-1 my-10 lg:my-0 mx-auto'>
                    <h2 className='uppercase text-xl text-[#ff014f] mb-6'>recources</h2>

                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Authentication </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> System Status </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Terms of Service </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Pricing </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                    <p className="text-xl text-[#878E99] mt-3 relative w-max one">
                        <a className='text-[#D2E6EA] hover:text-[#ff014f] cursor-pointer' href='#'> Working Policy </a>
                        <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                    </p>
                </div>

                <div className='col-span-1'>
                    <section className=" text-center">
                        <div className="flex flex-wrap justify-center">
                            <h2 className='uppercase text-xl text-[#ff014f] mb-6'>Subscribe to the newsletter</h2>
                            <div className=" w-full lg:w-full px-3">

                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-6">
                                        <input
                                            type="text"
                                            className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                            id="exampleInput90"
                                            placeholder="Name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group mb-6">
                                        <input
                                            type="email"
                                            className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                            id="exampleInput91"
                                            placeholder="Email address"
                                            required
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="w-full px-6 py-2.5 bg-[#ff014f] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                                        data-mdb-ripple="true"
                                        data-mdb-ripple-color="light"
                                    >
                                        Subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>

            </div>
            <div className="divider mt-10"></div>

            <div className='flex items-center gap-2 justify-center py-5'>
                <p className='text-xl text-[#878E99]'>© 2024. All rights reserved by</p>
                <p className="text-xl text-[#878E99] relative">
                    <a className='text-[#878E99] hover:text-[#ff014f] cursor-pointer' href='https://facebook.com/mdshijanali135' rel="noreferrer" target="_blank"> Md Shijan Ali </a>
                    <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                </p>

            </div>
        </div>
    )
}

export default Footer
